// private apis
export const FDD_API_URL = '/v1/fdds';
export const ZOR_API_URL = '/v1/zors';
export const STAGE_API_URL = '/v1/stages';
export const WORKBOOK_API_URL = '/v1/workbooks';
export const ZOR_MEMBER_API_URL = '/v1/zor-members';
export const FRANCHISEE_API_URL = '/v1/franchisees';
export const ZOR_DOCUMENT_API_URL = '/v1/zor-documents';
export const ZEE_DOCUMENT_API_URL = '/v1/zee-documents';
export const FEATURELOCKS_API_URL = '/v1/feature-locks';
export const ZOR_FINANCIAL_API_URL = '/v1/zor-financials';
export const STAGE_PROMPTS_API_URL = '/v1/aimei/stage-prompts';
export const AIMEI_PROMPTS_API_URL = '/v1/aimei/general-prompts';
export const DISCOVERY_STAGE_API_URL = '/v1/discovery-stages';
export const ZOR_GENERAL_SETTING_API_URL = '/v1/zor-general-settings';
export const ZEE_ONBOARDING_STATUS_API_URL = '/v1/zee-onboarding-status';
export const LINKS_API_URL = '/v1/links';
export const STORAGE_UPLOAD_API_URL = '/v1/storage/upload';
export const STORAGE_SIGNED_URL_API_URL = '/v1/storage/signed-url';
export const STORAGE_UPLOAD_AVATAR_API_URL = '/v1/storage/upload-avatar';
export const ZEE_CANDIDATE_API_URL = '/v1/zees-candidate';
export const ZOR_DATA_CENTER_LEADS_API_URL = '/v1/zor-data-center/leads';
export const ZOR_DATA_CENTER_CLOSED_API_URL =
  '/v1/consultant-data-center/closed';

// zee apis
export const ZEE_API_URL = '/v1/zees';
export const ZEE_FINANCIAL_API_URL = '/v1/zee-financials';
export const USER_BACKGROUND_API_URL = '/v1/users';
export const NOTES_API_URL = '/v1/notes';
export const USERS_API_URL = '/v1/users';

// partner consultant apis
export const CONSULTANT_API_URL = '/v1/consultants';
export const CONSULTANT_INDUSTRIES_API_URL = '/v1/consultant-industries';
export const CONSULTANT_DATA_CENTER_DISCOVERY_API_URL =
  '/v1/consultant-data-center/discovery';
export const CONSULTANT_DATA_CENTER_LEADS_API_URL =
  '/v1/consultant-data-center/leads';
export const LEADS_API_URL = '/v1/leads';
export const LEAD_REFERRALS_API_URL = '/v1/leads/referrals';

// clerk apis
export const JOIN_ORG_API_URL = '/api/join-org';
export const ORG_INVITE_API_URL = '/api/send-org-invitation';
export const REVOKE_ORG_INVITATION_API_URL = '/api/revoke-org-invitation';
export const CHANGE_PASSWORD_API_URL = '/api/change-password';
export const REFER_ORG_INVITATION_API_URL = '/api/refer-org-invitation';
export const REFER_LEAD_CANDIDATE_API_URL = '/api/refer-lead-candidate';
export const TRANSFER_CONSULTANT_CANDIDATE_DATA_API_URL =
  '/api/transfer-consultant-candidate-data';

// territories apis
export const HEATMAP_API_URL = '/api/heatmap';
export const ZEE_PERSONA_DATA_API_URL = '/v1/zee-persona-data';
export const ZIP_CODES_API_URL = '/api/zip-codes';
export const TERRITORIES_API_URL = '/api/territories';
export const STATE_COMPLIANCE_API_URL = '/api/states-compliance';
export const TERRITORIES_LIKES_API_URL = '/api/territories-likes';
export const TERRITORIES_REQUESTS_API_URL = '/api/territories-requests';
export const CENSUS_DATA_FIELDS_API_URL = '/api/acs-variables';
export const TERRITORY_SETTINGS_API_URL = '/api/territory-settings';
export const AVAILABLE_ZIP_CODES_COUNT_API_URL =
  '/api/available-zip-codes-count';

const PUBLIC_API_URLs: Array<string> = [
  // clerk apis
  ORG_INVITE_API_URL,
  REFER_ORG_INVITATION_API_URL,
  CHANGE_PASSWORD_API_URL,
  // territories apis
  CENSUS_DATA_FIELDS_API_URL,
];

export { PUBLIC_API_URLs };
